import React from 'react';
import { Typography } from '@mui/material';

import { statusTextSuccess } from 'utils/color-styles';

export const EventDurationText = ({ eventDuration }: { eventDuration: number | null }) => {
  if (!eventDuration) {
    return null;
  }
  return (
    <Typography
      variant="body1"
      color={eventDuration >= 12 || eventDuration <= 0 ? 'error' : statusTextSuccess}
      style={{ marginTop: 10 }}
    >
      This event is {eventDuration} hours long
    </Typography>
  );
};
